import React from "react";

import logo from "assets/img/trademarks-logo.png";

import styled from "styled-components";

const StyledBrand = styled.img`
  max-height: 45px;
  @media (max-width: 767px) {
    max-height: 10vw;
  }
`;

export default function Brand() {
  return <StyledBrand src={logo} />;
}
